export interface VerificationStep {
    step: string;
    title: string;
    description?: any;
    actions?: any;
    after?: any;
    [rest: string]: any;
}
export const VerificationStep = ({ step, title, description, actions, after, ...rest}: VerificationStep) => {
    return (
        <div className="bg-base-300 rounded-[24px] px-[32px] md:px-20 py-[40px] md:py-[32px] relative" { ...rest }>
            <h4 className="absolute left-6 md:left-[40px] font-bold text-2xl text-secondary">{step}</h4>
            <h4 className={`
                        font-bold text-2xl pl-8 md:pl-0`}
                        >{title}
            </h4>
            <div className="flex flex-col md:flex-row mt-6 relative gap-y-8">
                <div className="flex-1 flex flex-col ">
                    {description}
                </div>
                <div className="flex-1">
                    {actions}
                </div>
            </div>
            {after}
        </div>
    )
}